<template>
  <div id="signup">
    <div class="signup-form">
      <h2>Nuevo Device</h2>
      <form @submit.prevent="onSubmit">
        <div class="input">
          <label for="sigfoxId">Sigfox Id</label>
          <input
            id="sigfoxId"
            v-model="sigfoxId"
            type="text"
          >
        </div>
        <div class="input">
          <label for="description">description</label>
          <input
            id="description"
            v-model="description"
            type="text"
          >
        </div>
        <div class="input">
          <label for="status">status</label>
          <input
            id="status"
            v-model="status"
            type="text"
          >
        </div>
        <div class="input">
          <label for="deviceType">deviceType</label>
          <input
            id="deviceType"
            v-model="deviceType"
            type="text"
          >
        </div>
        <div class="input">
          <label for="subprojectId">SubProject Id</label>
          <input
            id="subprojectId"
            v-model="subprojectId"
            type="number"
          >
        </div>

        <div class="submit">
          <button type="submit">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      sigfoxId: '',
      description: '',
      type: 'read',
      status: '',
      deviceType: '',
      subprojectId: ''
    }
  },
  methods: {
    onAddHobby () {
      const newHobby = {
        id: Math.random() * Math.random() * 1000,
        value: ''
      }
      this.hobbyInputs.push(newHobby)
    },
    onDeleteHobby (id) {
      this.hobbyInputs = this.hobbyInputs.filter(hobby => hobby.id !== id)
    },
    onSubmit () {
      const formData = {
        sigfoxId: this.sigfoxId,
        description: this.description,
        userType: this.type,
        status: this.status,
        deviceType: this.deviceType,
        subprojectId: parseInt(this.subprojectId)
      }
      this.$store.dispatch('addDevice', formData)
    }
  }
}
</script>

<style scoped>
  .signup-form {
    width: 400px;
    margin: 30px auto;
    border: 1px solid #eee;
    padding: 20px;
    box-shadow: 0 2px 3px #ccc;
  }

  .input {
    margin: 10px auto;
  }

  .input label {
    display: block;
    color: #4e4e4e;
    margin-bottom: 6px;
  }

  .input.inline label {
    display: inline;
  }

  .input input {
    font: inherit;
    width: 100%;
    padding: 6px 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
  }

  .input.inline input {
    width: auto;
  }

  .input input:focus {
    outline: none;
    border: 1px solid #521751;
    background-color: #eee;
  }

  .input select {
    border: 1px solid #ccc;
    font: inherit;
  }

  .hobbies button {
    border: 1px solid #521751;
    background: #521751;
    color: white;
    padding: 6px;
    font: inherit;
    cursor: pointer;
  }

  .hobbies button:hover,
  .hobbies button:active {
    background-color: #8d4288;
  }

  .hobbies input {
    width: 90%;
  }

  .submit button {
    border: 1px solid #521751;
    color: #521751;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
  }

  .submit button:hover,
  .submit button:active {
    background-color: #521751;
    color: white;
  }

  .submit button[disabled],
  .submit button[disabled]:hover,
  .submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
  }
</style>
